module.exports = __webpack_public_path__ + "img/a9ea402.jpg";